import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "contexts/AuthContext";
import { useToast } from "contexts/ToastContext";
import { useForm } from "react-hook-form";
import { ResetPasswordFormType } from "types";
import { resetPasswordSchema } from "validations";

export const useResetPassword = () => {
  const { resetPassword } = useAuth();
  const { showError } = useToast();

  const methods = useForm<ResetPasswordFormType>({
    resolver: yupResolver(resetPasswordSchema),
    mode: "onChange",
    defaultValues: {
      newPassword: "",
      confirmNewPassword: "",
    },
  });

  const mutation = useMutation({
    mutationFn: resetPassword,
    onError: (error: unknown) => {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Reset password failed. Please try again.";
      showError("Reset password failed", errorMessage);
    },
  });

  const onSubmit = async (oobCode: string, data: ResetPasswordFormType) => {
    if (oobCode)
      mutation.mutate({
        oobCode: oobCode,
        newPassword: data.newPassword,
      });
  };

  return {
    methods,
    onSubmit,
    isSubmitting: mutation.isPending,
    isSuccess: mutation.isSuccess,
    resetMutation: mutation.reset,
  };
};
